import React, { useState, useEffect } from "react";
import { AddAdmin } from "../../pages";
import * as yup from 'yup';
import { MimaToastUtil } from "../../components";
import { AdminController } from "../../controllers";
import constant from "../../utils/constant";
import { toJS } from "mobx";
import { adminStore } from "../../stores";

const AddAdminContainer = ({ closeModal, }) => {
    const [loading, setLoading] = useState(false);
  
    const validationSchema = () => {
        return yup.object({
            firstname: yup.string().required('First Name is required'),
            lastname: yup.string().required('Last Name is required'),
            email: yup.string().trim().email('Enter a valid Email').required('Email Address is required'),
            mobile: yup.string().required('Mobile number is required'),
            role: yup.string().required('Role is required'),
        });
    };

    const onSubmit = async (values) => {
        setLoading(true);
        const payload = {
            firstname: values.firstname,
            lastname: values.lastname,
            email: values.email,
            mobile: values.mobile,
            role: values.role,
        }

        const { status, errorMessage } = await AdminController.createAdminUsers(payload);

        if (status === constant.Success) {            
            MimaToastUtil.success({ message: 'Admin user was created successfully' })          
           setLoading(false);
           return closeModal();
        }  else {
            setLoading(false);
            MimaToastUtil.error({ message: errorMessage })
        }
    }

 

    return (
        <AddAdmin           
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            closeModal={closeModal}
            roles={toJS(adminStore.roles)}
            loading={loading}
        />
    )
}
export default AddAdminContainer;